import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishPreparationPage } from "../../dish-create/dish-cost/dish-preparation/dish-preparation";


/**
 * Generated class for the DishViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-preparation',
    templateUrl: 'dish-view-preparation.html',
})
export class DishViewPreparationPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,) {
    }

    edit() {
        if (this.globals.checkLimitsByLicense('dishes','recipe')) {
            this.navCtrl.push(DishPreparationPage, {
                dish_uid: this.dish.UID,
                recipe: this.dish.recipe,
                tools: this.dish.tools,
                time: this.dish.time,
                preparation: this.dish.preparation,
                dish_name: this.globals.nameLangSelectDish(this.dish),
                dish: this.dish,
                update: true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-preparation/dish-view-preparation.ts